import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../shared/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {Agency} from '../../models/agency';
import {environment} from '../../../environments/environment';
import {CuiBaseComponent} from '@cicero/webui/lib/core/shared/base-component';

const blockedError = 'Kodeordet til denne bruger er blevet indtastet forkert tre gange i træk. ' +
  'Brugeren er blokeret i 20 minutter fra blokeringstidspunktet. Kontakt evt. din systemadministrator.';
const forbiddenError = 'Forkert brugernavn eller kodeord';

/**
 * Shows a login form and agency name.
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends CuiBaseComponent implements OnInit {
  loading = true;
  agency?: Agency;
  username: string;
  password: string;

  constructor(private auth: AuthenticationService,
              private router: Router,
              private route: ActivatedRoute,
              private snackBar: MatSnackBar) {
    super();
  }

  ngOnInit() {
    const agencySub = this.route.params
      .do(() => this.loading = true)
      .switchMap(params => this.auth.getAgency(params.agencyISIL.toUpperCase()))
      .do(() => this.loading = false)
      .subscribe(agency => this.agency = agency);

    this.pushSubscription(agencySub);
  }

  /**
   * Atempt a login.
   * The user is redirected if it succeeds.
   * If it fails a snackbar is shown.
   */
  submit() {
    this.snackBar.dismiss();

    const agencyISIL = this.route.snapshot.params.agencyISIL.toUpperCase();

    this.auth.login(this.username, this.password, agencyISIL)
      .subscribe(
        () => this.redirect(),
        response => {
          this.snackBar.open(
            response.error === 'BLOCKED' ? blockedError : forbiddenError,
            undefined,
            {duration: environment.errorMessageDurationMs}
          );
        }
      );
  }

  /**
   * Redirect the user away from the login page.
   * If a redirectTo query parameter is present, redirect to it.
   * Otherwise redirect to the front page for the agency.
   */
  private redirect() {
    const redirectTo = this.route.snapshot.queryParams.redirectTo;

    if (redirectTo) {
      this.router.navigateByUrl(redirectTo);
    } else {
      this.router.navigate(['../pick-up-list/search'], {relativeTo: this.route});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/login/login.component.ts